declare let API_HREF: string;
// Dependencies
import { Loader } from '@googlemaps/js-api-loader';
import axios from 'axios';
import React, { ComponentType, FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Components
import Loading from '../component/loading/loading';
// Actions
import { setConfig, setGoogle } from '../component/header/redux/actions';
import { setList, setListLocales } from '../component/locale/redux/actions';
// Types
import { AppState } from '../reducers';

type PublicRouteProps = {
    component: ComponentType
};

const PublicRoute: FC<PublicRouteProps> = ({ component: Component, ...rest }): ReactElement => {
    const dispatch = useDispatch();
    const client_id = useSelector((state: AppState) => state.header.client_id);
    if (client_id === null) {
        const result = /.([^.]+)/.exec(window.location.host);
        let customer_identifier = result !== null ? result[0] : 'vat-dev';
        let domain_name = window.location.host;
        if (window.location.host.includes('localhost')) {
            customer_identifier = 'dev';
            domain_name = 'dev.facilitatrip.com';
            // domain_name = 'dev.tripmci.com';
            // customer_identifier = 'vat-dev';
            // domain_name = 'vat-dev.facilitatrip.com';
        }
        axios({
            method: 'GET',
            url: `${API_HREF}instances/?customer_identifier=${customer_identifier}&domain_name=${domain_name}`,
            headers: { 'X-Public-Request': '1' },
        }).then((response) => {
            dispatch(setConfig(response.data));
            dispatch(setList(response.data.activated_locales));
            if (response.data.favicon !== undefined && response.data.favicon !== null && response.data.favicon.thumbnail_little !== undefined && response.data.favicon.url !== undefined) {
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = (response.data.favicon.thumbnail_little !== null ? response.data.favicon.thumbnail_little : response.data.favicon.url);
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            let google_key = null;
            for (let i = 0; i < response.data.keys.length; i++) {
                if (response.data.keys[i].identifier === 'google_api') {
                    google_key = response.data.keys[i].value;
                    break;
                }
            }
            const loader = new Loader({
                apiKey: google_key,
                version: 'beta',
                libraries: ['places', 'marker']
            });
            loader
                .load()
                .then((google) => {
                    dispatch(setGoogle(google));
                })
                .catch(() => {
                    // do something
                });
        }).catch((error) => {
            console.log('error : ', error);
        });
        axios({
            method: 'GET',
            url: `${API_HREF}locales/?ordering=id`,
            headers: { 'X-Public-Request': '1' },
        }).then((response) => {
            dispatch(setListLocales(response.data));
        }).catch((error) => {
            console.log('error : ', error);
        });
        return <Loading />;
    }
    return <Component {...rest} />;
};

export default PublicRoute;